import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_FHIRResource, newFHIRResourceTemplate } from '@app/fhir-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_FHIRResource } from '../../../_entity.js';
import { Renderer_FHIRResourceHeader } from './renderers/Renderer_FHIRResourceHeader/Renderer_FHIRResourceHeader.js';
import { Editor_FHIRResource } from '../../Page_FHIRManager/Editor_FHIRResource/Editor_FHIRResource.js';
import './Manager_FHIRResource.scss';
import { LL_V_L } from "@nu-art/thunderstorm-frontend/index";
const Editor_FHIRResource_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-fhir-resource', children: [_jsx(Renderer_FHIRResourceHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_FHIRResource, { editable: props.editable, editMode: props.renderArgs.editMode, hideHeader: true })] });
export const Manager_FHIRResource = createWorkHubManager({
    module: ModuleFE_FHIRResource,
    dbDef: DBDef_FHIRResource,
    defaultItem: newFHIRResourceTemplate,
    labelResolver: (item) => item.label ?? "New FHIR Resource",
    EditorComponent: Editor_FHIRResource_Wrapper,
});
//# sourceMappingURL=Manager_FHIRResource.js.map